import styled from "@emotion/styled";

export const DashboardContainer = styled.div`
  padding: 20px 70px;
  min-height: 0; /* Allow flex children to shrink */

  /* Ensure grid rows have equal height */
  .mantine-Grid-root {
    align-items: stretch;
  }

  @media (max-width: 768px) {
    padding: 12px 0;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  > * {
    width: 100%;
    height: 100%;
    min-height: 180px;
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 768px) {
    > * {
      max-width: 100%;
    }
  }
`;
